import { client } from '../http';

export default {
  async getAccessCodeUrl(idNumber, credentialsId) {
    const response = await client.get(`/api/get-access-code/${idNumber}/${credentialsId}`);
    return response.data.url;
  },

  async getJointAccountRedirectUrl(idNumber, requestId) {
    const response = await client.get(`/api/no-auth/get-joint-account-redirect-url/${idNumber}/${requestId}`);
    return response;
  },

  async convertAccessCodeToToken(accessCode, state) {
    const url = encodeURI(`/api/no-auth/convert-access-code/${encodeURIComponent(accessCode)}/${state}`);
    const response = await client.get(url);
    return response.data;
  },

  async getConnectionState(credentialsId) {
    const response = await client.get(`/api/connection-state/${credentialsId}`);
    return response.data;
  },
};
